//Can not be performed via useParams because it is not directly connected to router.
export const getSubsetAndItemParams = (
  pathname: string
): { itemId: string | undefined; subsetId: string | undefined } => {
  const parsedPathname = pathname.split('/');
  const itemIdIndex = parsedPathname.indexOf('item');
  const subsetIdIndex = parsedPathname.indexOf('subset');
  const itemId =
    itemIdIndex === -1 ? undefined : parsedPathname[itemIdIndex + 1];
  const subsetId =
    subsetIdIndex === -1 ? undefined : parsedPathname[subsetIdIndex + 1];

  return { itemId, subsetId };
};
